<template>
    <toolbar-option type="stacked" :message="message">
        <template slot="primary">
            <dropdown
                :value="selected"
                :options="options"
                native
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import gql from 'graphql-tag';
import baseOption from '@/options/mixins/base-option';

export default {
    name: 'table-data-source',
    mixins: [baseOption],

    apollo: {
        tableItems: {
            query: gql`
                {
                    item(path: "/sitecore/content/Data/Global/Table/Tables") {
                        children {
                            id
                            name
                        }
                    }
                }
            `,
            update(data) {
                return data.item.children;
            },
        },
    },

    data() {
        return {
            displayName: 'Data Source',
            message: '* A data source must be selected from items in /sitecore/content/Data/Global/Table/Tables',
            selected: '',
        };
    },

    computed: {
        options() {
            const noneOption = { text: 'None', value: '' };

            if (!this.tableItems) return [noneOption];

            return [
                noneOption,
                ...this.tableItems.map(item => ({ text: item.name, value: item.id })),
            ];
        },
    },

    watch: {
        tableItems() {
            if (!this.tableItems) return;

            this.onSelectedElement();
        },
    },

    methods: {
        async onInput(selected) {
            this.selected = selected;
            this.selectedElements.forEach(elem => elem.setElementData('table-data-source', selected));
        },

        onSelectedElement() {
            this.selected = this.selectedElements[0].getElementData('table-data-source') || '';
        },
    },
};
</script>
